export const SHOPPING_CART_PRODUCT_ADD = 'SHOPPING_CART_PRODUCT_ADD';
